import React from 'react';
import { Navigate } from 'react-router-dom';
import { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';

import { TABS } from 'containers/Navigation';

// This component wraps the children and handles permission checking
// It should be used inside a Route's element prop
export function PermissionGuard({ children, store, deniedPatterns = [] }) {
  const { permissionStore } = store;
  const isDenied = permissionStore.isDenied(deniedPatterns);

  if (!isDenied) {
    return children;
  }

  const filteredRoutes = TABS.filter((tab) => permissionStore.isDenied(tab.deniedPatterns) === false);
  const [filteredRoute] = filteredRoutes;

  if (filteredRoute) {
    return <Navigate to={filteredRoute.link} replace />;
  }
  return null;
}

export const ProtectedRoute = compose(inject('store'), observer)(PermissionGuard);
